import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UserDTO, PasswordStrengthDTO } from '../../../api/plyca-dtos';
import { UIService } from '../../../ui.service';
import { WaitLoadingService } from '../../../components/common/waitLoading/wait-loading.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/AppState';
import { SessionInfo } from '../../../api/UserPrefs-dto';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../auth.service';
import { PlycaErrorHandler } from '../../../../http/PlycaErrorHandler';
import { ConfirmationService, Message } from 'primeng-lts/api';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../../components/common/baseComponent/base.component';


@Component({
  selector: 'user-password',
  templateUrl: 'user-password.template.html',
  providers: [DialogService]
})
export class UserPasswordComponent extends BaseComponent implements OnInit {

  public user: UserDTO;
  public passOld: string;
  public passNew: string;
  public passConfirm: string;
  public strength: string;
  public strengthErrorMsg: string;
  private validStrengthPassword = false;



  constructor(private authService: AuthService,
    private uiService: UIService, private confirmationService: ConfirmationService, private plycaErrorHandler: PlycaErrorHandler,
    private waitService: WaitLoadingService, private store: Store<AppState>, private changeDetector: ChangeDetectorRef,
    private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.subscribe(
      this.store.select('user'), (sesInfo: SessionInfo) => {
        this.user = sesInfo.user;
      });


  }

  public updatePassword(): void {

    if (!this.passNew || !this.passOld || !this.validStrengthPassword || this.passNew !== this.passConfirm) {
      this.uiService.showMessage(this.translateService.instant('UserPrefs.password.invalid')
        , this.translateService.instant('General.warn'));

    } else {

      this.confirmationService.confirm({
        message: this.translateService.instant('UserPrefs.password.question'),
        accept: () => {
          this.waitService.startWaiting();
          this.subscribe(
            this.authService.updatePassword(this.passOld, this.passNew), () => {
              this.waitService.cancelWaiting();
              this.uiService.showSuccess(this.translateService.instant('UserPrefs.password.success')
                , this.translateService.instant('General.warn'));
            },
            () => {
              this.waitService.cancelWaiting();
              this.uiService.showMessage(this.translateService.instant('UserPrefs.password.failure')
                , this.translateService.instant('General.warn'));
            });
        },
        reject: () => {
        }
      });
    }
  }

  public isValidPassword(ignoreStrengthPassword = false): boolean {
    let newPassDefined = this.isNotEmpty(this.passNew);
    let valid = this.isNotEmpty(this.passOld)
      && newPassDefined
      && (ignoreStrengthPassword || this.validStrengthPassword);
    if (newPassDefined) {
      if (this.passNew === this.passOld) {
        this.strength = 'same';
        valid = false;
      } else if (this.passNew !== this.passConfirm) {
        this.strength = 'different';
        valid = false;
      }
    }
    return valid;
  }

  public calculatePasswordStrength() {
    this.isValidPassword(true);
    if (this.isNotEmpty(this.passNew) !== undefined && this.passNew === this.passConfirm) {
      this.strengthErrorMsg = undefined;
      this.subscribe(
        this.authService.passwordStrength(this.user.identifier, this.passNew, null),
        (passStrength: PasswordStrengthDTO) => {
          this.strength = passStrength.strength;
          this.validStrengthPassword = passStrength.valid;
          this.strengthErrorMsg = (this.validStrengthPassword) ? undefined : passStrength.cause;
        },
        error => {
          this.waitService.cancelWaiting();
          this.plycaErrorHandler.showServerError(error);
        }
      );
    }
  }

  private isNotEmpty(text: string): boolean {
    return text !== undefined && text.trim() !== '';
  }

}
